import React, { Component } from 'react'
import Slide from './Slide'
import './slider.css'

export default class Slider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      images: ['grano-1200', 'mosaicos'],
      descriptions: ['Baldosas en Grano', 'Mosaicos'],
      links: ['/galeria', '/mosaicos'],
      currentIndex: 0,
      translateValue: 0,
    }
    this.goToNextSlide = this.goToNextSlide.bind(this);
    this.goToPrevSlide = this.goToPrevSlide.bind(this);
    this.Interval = setInterval(() => {
      this.goToNextSlide();
    }, 4000)
  }

  goToPrevSlide = () => {
    if (this.state.currentIndex === 0) {
      this.setState({ currentIndex: this.state.image.length - 1 })
    }
    this.setState({ currentIndex: this.state.currentIndex - 1 });
  }

  goToNextSlide = () => {
    if (this.state.currentIndex === this.state.images.length - 1) {
      return this.setState({
        currentIndex: 0,
      })
    }
    this.setState({
      currentIndex: this.state.currentIndex + 1,
    });
  }

  slideWidth = () => {
    return document.querySelector('.slide').clientWidth;
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    const { currentIndex, descriptions, links } = this.state;
    return (
      <div className="slider">
        {
          this.state.images.map((image, index) => (
            <Slide key={index} image={image} description={descriptions[index]} url={links[index]} visible={(index == currentIndex) ? "block" : "none"} />
          ))
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/slider/Slider.jsx